import {Endpoint} from "./Endpoint.js";

export class FootprintEndpoint extends Endpoint {
    static url() {
        return '/api/footprint'
    }

    method() {
        return 'POST'
    }

    needsAuthorization() {
        return false;
    }
}
